import { render, staticRenderFns } from "./DomainTagInput.vue?vue&type=template&id=526466b8&scoped=true&"
import script from "./DomainTagInput.vue?vue&type=script&lang=js&"
export * from "./DomainTagInput.vue?vue&type=script&lang=js&"
import style0 from "./DomainTagInput.vue?vue&type=style&index=0&id=526466b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526466b8",
  null
  
)

export default component.exports